import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { ImportData } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';
import { TermsAndConditionsInfoComponent } from '../dialogs/terms-and-conditions-info/terms-and-conditions-info.component';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit, OnDestroy {
  public agreedToTerms = false;
  public activeAccount: AccountInfo | undefined;
  public currentUser!: ImportData;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private userService: UserService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.userService.currentUser$.subscribe((result) => {
      if (result.Username) {
        this.currentUser = result;
      }
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  public check(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
  }

  public getStartedClick(): void {
    this.router.navigate(['/calculator']);
  }

  public viewTermsAndConditions(): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        title: 'Terms & Conditions',
        dialogContent: TermsAndConditionsInfoComponent,
      },
    });
  }
}
